import {show_api_error} from "../../components/shared/api_errors";

export default {

  // общая функция отправки запроса на сервер.
  request(req, cb, cb_fail) {
    if (req === undefined) {
      console.error('API Error: request object is empty.');
      return false;
    };
    // установка параметров по умолчанию.
    if (req.url === undefined) return false;
    if (req.payload === undefined) req.payload = {};
    if (req.format === undefined) req.format = 'GET';
    if (req.processData === undefined) req.processData = true;
    if (req.contentType === undefined) req.contentType = undefined;

    if (cb === undefined)      cb = this.defaultSuccessCB;
    if (cb_fail === undefined) cb_fail = this.defaultFailCB;

    console.log('API: ', req.format, req.url, " with payload:", req.payload);
    console.log('API REQUEST PARAMS: ', req);

    // Отправка запроса
    $.ajax({
        url: req.url,
        data: req.payload,
        dataType: "json",
        type: req.format,
        processData: req.processData,
        contentType: req.contentType,
      })
      .done(function (data) {
        console.log('API:', req.url, 'success');
        cb(data);
      })
      .fail(function (jqXHR, textStatus) {
        console.log('API:', req.url, 'error');
        cb_fail(jqXHR, textStatus, req.url);
      });
  },


  defaultSuccessCB(data) {
    //console.log(data);
  },

  // вне компонента — тост показывается через корневой инстанс, см. set_toast_host
  defaultFailCB(jqXHR, textStatus, url) {
    show_api_error(null, jqXHR);
  },
}
